import axios from 'axios';
import {
  Container, Grid, Backdrop, CircularProgress, Typography, Checkbox, Button, MenuItem,
  Select, InputLabel, FormLabel, TextField
} from '@material-ui/core';
import { Form } from 'react-bootstrap';
import React, { PureComponent } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import PhoneInput from 'react-phone-input-2';
import { getAPIUrl, isValidEmail, isValidPhone } from '../../helpers/CommonHelper';
import ReCAPTCHA from "react-google-recaptcha";
import 'react-phone-input-2/lib/bootstrap.css';

class DriverRegistrationComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      tnc: true,
      isLoading: false,
      vehicleType: 'sedan',
      licenseExpiry: new Date(),
      captcha: false,
      region: 'Texas'
    };
  }

  handleSubmit = () => {
    if (this.state.firstName == undefined
      || this.state.lastName == undefined
      || this.state.phone1 == undefined
      || this.state.street == undefined
      || this.state.region == undefined
      || this.state.postalCode == undefined
      || this.state.vehicleType == undefined
      || this.state.licenseNumber == undefined
      || this.state.licenseExpiry == undefined
      || this.state.vehicleColor == undefined
      || this.state.password == undefined
      || this.state.firstName === ''
      || this.state.lastName === ''
      || this.state.phone1 === ''
      || this.state.street === ''
      || this.state.region === ''
      || this.state.postalCode === ''
      || this.state.vehicleType === ''
      || this.state.licenseNumber === ''
      || this.state.licenseExpiry === ''
      || this.state.vehicleColor === ''
      || this.state.licensePhoto == undefined
      || this.state.insurancePhoto == undefined
    ) {
      alert('One or more field is missing');
      return;
    }

    if (!isValidEmail(this.state.email)) {
      alert('Email is Invalid');
      return;
    }

    if (this.state.password.length < 8) {
      alert('Password should be min 8 characters');
      return;
    }

    if (!isValidPhone(this.state.phone1)) {
      alert('Phone number is Invalid');
      return;
    }

    if (!this.state.captcha) {
      alert('Please verify Captcha');
      return;
    }

    const formData = new FormData();
    
    // Update the formData object
    formData.append("emailId", this.state.email);
    formData.append("password", this.state.password);
    formData.append("firstName", this.state.firstName);
    formData.append("lastName", this.state.lastName);
    formData.append("phoneNumber1", `+${this.state.phone1}`);
    formData.append("addStreet", this.state.street);    
    formData.append("addRegion", this.state.region);
    formData.append("addCountry", "US");
    formData.append("addPinCode", this.state.postalCode);
    formData.append("vehicleType", this.state.vehicleType);
    formData.append("licenseNumber", this.state.licenseNumber);
    formData.append("licenseExpiry", this.state.licenseExpiry);
    formData.append("vehicleColor", this.state.vehicleColor);
    formData.append("license", this.state.licensePhoto);
    formData.append("insurance", this.state.insurancePhoto);

    this.setState({
      isLoading: true,
    });

    axios.post(`${getAPIUrl()}/driver/register`, formData, {
      timeout: 30000,
    }).then(() => {
      this.setState({
        isLoading: false,
      });
      alert('Driver registered successfully!! Your request is being reviewed, we will notify once it is accepted.');
      window.location.href = "https://xpresspac.com";
    }).catch((error) => {
      this.setState({
        isLoading: false,
      });
      if (error.response && error.response.status === 400) {
        alert(error.response.data.message);
      } else if (error.response && error.response.status === 413) {
        alert('Uploaded file should be less than 2mb');
      } else {
        console.error(error);
        alert('Something went wrong!!!');
      }
    });
  }

  inputChanged = (value, key) => {
    this.setState({
      [key]: value,
    });
  }

  handleTNCChange = () => {
    this.setState({
      tnc: !this.state.tnc,
    });
  }

  handleParcelSizeChange = (event) => {
    this.setState({
      vehicleType: event.target.value,
    });
  }

  handleRegionChange = (event) => {
    this.setState({
      region: event.target.value,
    });
  }

  captchaOnChange = () => {
    this.setState({
      captcha: true
    });
  }

  onFileChange = async(event, key) => {
    const base64 = await this.convertBase64(event.target.files[0]);
    this.setState({ [key]: base64 });
  };

  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  render() {
    return (
      <Container>
        <Grid container className="margin-top10" direction="row" justify="center" alignItems="flex-start">
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h5" gutterBottom>
                Driver Registration
            </Typography>
            <Form>
              <Typography variant="h6" gutterBottom>
                Personal details
              </Typography>
              <Form.Group>
                <TextField
                  label="First name"
                  onChange={(event) => this.inputChanged(event.target.value, 'firstName')}
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 50 }}
                  required
                />
              </Form.Group>
              <Form.Group>
                <TextField
                  label="Last name"
                  onChange={(event) => this.inputChanged(event.target.value, 'lastName')}
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 50 }}
                  required
                />
              </Form.Group>
              <Form.Group>
                <TextField
                  label="Email address"
                  onChange={(event) => this.inputChanged(event.target.value, 'email')}
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 50 }}
                  required
                />
              </Form.Group>
              <Form.Group>
                <TextField
                  label="Password (min 8 characters)"
                  onChange={(event) => this.inputChanged(event.target.value, 'password')}
                  variant="outlined"
                  type="password"
                  size="small"
                  inputProps={{ maxLength: 50 }}
                  required
                />
              </Form.Group>
              <Form.Group>
                <PhoneInput
                  country="us"
                  onlyCountries={['us']}
                  value={this.state.phone1}
                  placeholder="Phone number"
                  disableDropdown
                  countryCodeEditable={false}
                  onChange={(phone) => this.inputChanged(phone, 'phone1')}
                />
              </Form.Group>
              <hr />
              <Typography variant="h6" gutterBottom>
                Address details
              </Typography>
              <Form.Group>
                <TextField
                  label="Street"
                  onChange={(event) => this.inputChanged(event.target.value, 'street')}
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 50 }}
                  required
                />
              </Form.Group>
              <Form.Group>
                <TextField
                  label="City"
                  onChange={(event) => this.inputChanged(event.target.value, 'city')}
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 50 }}
                  required
                />
              </Form.Group>
              <Form.Group>
                <InputLabel id="parcel-size-select-label">State</InputLabel>
                <Select
                  labelId="region-select-label"
                  id="region-select"
                  value={this.state.region}
                  style={{ width: '100%' }}
                  onChange={this.handleRegionChange}
                >
                  <MenuItem value="Alabama">Alabama</MenuItem>
                  <MenuItem value="Alaska">Alaska</MenuItem>
                  <MenuItem value="Arizona">Arizona</MenuItem>
                  <MenuItem value="Arkansas">Arkansas</MenuItem>
                  <MenuItem value="California">California</MenuItem>
                  <MenuItem value="Colorado">Colorado</MenuItem>
                  <MenuItem value="Connecticut">Connecticut</MenuItem>
                  <MenuItem value="Delaware">Delaware</MenuItem>
                  <MenuItem value="Florida">Florida</MenuItem>
                  <MenuItem value="Georgia">Georgia</MenuItem>
                  <MenuItem value="Hawaii">Hawaii</MenuItem>
                  <MenuItem value="Idaho">Idaho</MenuItem>
                  <MenuItem value="Illinois">Illinois</MenuItem>
                  <MenuItem value="Indiana">Indiana</MenuItem>
                  <MenuItem value="Iowa">Iowa</MenuItem>
                  <MenuItem value="Kansas">Kansas</MenuItem>
                  <MenuItem value="Kentucky">Kentucky</MenuItem>
                  <MenuItem value="Louisiana">Louisiana</MenuItem>
                  <MenuItem value="Maine">Maine</MenuItem>
                  <MenuItem value="Maryland">Maryland</MenuItem>
                  <MenuItem value="Massachusetts">Massachusetts</MenuItem>
                  <MenuItem value="Michigan">Michigan</MenuItem>
                  <MenuItem value="Minnesota">Minnesota</MenuItem>
                  <MenuItem value="Mississippi">Mississippi</MenuItem>
                  <MenuItem value="Missouri">Missouri</MenuItem>
                  <MenuItem value="Montana">Montana</MenuItem>
                  <MenuItem value="Nebraska">Nebraska</MenuItem>
                  <MenuItem value="Nevada">Nevada</MenuItem>
                  <MenuItem value="New Hampshire">New Hampshire</MenuItem>
                  <MenuItem value="New Jersey">New Jersey</MenuItem>
                  <MenuItem value="New Mexico">New Mexico</MenuItem>
                  <MenuItem value="New York">New York</MenuItem>
                  <MenuItem value="North Carolina">North Carolina</MenuItem>
                  <MenuItem value="North Dakota">North Dakota</MenuItem>
                  <MenuItem value="Ohio">Ohio</MenuItem>
                  <MenuItem value="Oklahoma">Oklahoma</MenuItem>
                  <MenuItem value="Oregon">Oregon</MenuItem>
                  <MenuItem value="Pennsylvania">Pennsylvania</MenuItem>
                  <MenuItem value="Rhode Island">Rhode Island</MenuItem>
                  <MenuItem value="South Carolina">South Carolina</MenuItem>
                  <MenuItem value="South Dakota">South Dakota</MenuItem>
                  <MenuItem value="Tennessee">Tennessee</MenuItem>
                  <MenuItem value="Texas">Texas</MenuItem>
                  <MenuItem value="Utah">Utah</MenuItem>
                  <MenuItem value="Vermont">Vermont</MenuItem>
                  <MenuItem value="Virginia">Virginia</MenuItem>
                  <MenuItem value="Washington">Washington</MenuItem>
                  <MenuItem value="West Virginia">West Virginia</MenuItem>
                  <MenuItem value="Wisconsin">Wisconsin</MenuItem>
                  <MenuItem value="Wyoming">Wyoming</MenuItem>
                </Select>
              </Form.Group>
              <Form.Group>
                <TextField
                  label="Postal code"
                  onChange={(event) => this.inputChanged(event.target.value, 'postalCode')}
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 10 }}
                  required
                />
              </Form.Group>
              <hr />
              <Typography variant="h6" gutterBottom>
                Vehicle details
              </Typography>
              <Form.Group>
                <InputLabel id="parcel-size-select-label">Insurance Photo</InputLabel>
                <input type="file" onChange={e => this.onFileChange(e, "insurancePhoto")} data-max-size="4098" accept="image/png, image/jpeg" />
              </Form.Group>
              <Form.Group>
                <TextField
                  label="License number"
                  onChange={(event) => this.inputChanged(event.target.value, 'licenseNumber')}
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 12 }}
                  required
                />
              </Form.Group>
              <Form.Group>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    minDate={new Date()}
                    margin="normal"
                    format="dd/MM/yyyy"
                    id="date-picker-inline"
                    value={this.state.licenseExpiry}
                    label="License expires on"
                    onChange={(event) => this.inputChanged(event.toISOString(), 'licenseExpiry')}
                    KeyboardButtonProps={{
                      'aria-label': 'license date',
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Form.Group>
              <Form.Group>
                <InputLabel id="parcel-size-select-label">License Photo</InputLabel>
                <input type="file" onChange={e => this.onFileChange(e, "licensePhoto")} data-max-size="4098" accept="image/png, image/jpeg" />
              </Form.Group>
              <Form.Group>
                <TextField
                  label="Vehicle color"
                  onChange={(event) => this.inputChanged(event.target.value, 'vehicleColor')}
                  variant="outlined"
                  size="small"
                  required
                />
              </Form.Group>
              <Form.Group>
                <InputLabel id="parcel-size-select-label">Vehicle type</InputLabel>
                <Select
                  labelId="parcel-size-select-label"
                  id="parcel-size-select"
                  value={this.state.vehicleType}
                  style={{ width: '100%' }}
                  onChange={this.handleParcelSizeChange}
                >
                  <MenuItem value="sedan">Sedan</MenuItem>
                  <MenuItem value="suv">SUV</MenuItem>
                  <MenuItem value="truck">Truck</MenuItem>
                </Select>
              </Form.Group>
            </Form>
          </Grid>
        </Grid>
        <Grid container className="margin-top10" direction="row" justify="center" alignItems="flex-start">
          <ReCAPTCHA
            sitekey="6LcLcXUbAAAAAFqICvYuDj7mCiT7bn0mCf4eiTxz"
            onChange={this.captchaOnChange}
          />
        </Grid>
        <Grid container className="margin-top10" direction="row" justify="center" alignItems="flex-start">
          <Grid item>
            <Checkbox
              checked={this.state.tnc}
              onChange={this.handleTNCChange}
              name="tnc"
            />
            <span>By Clicking Submit, you agree with our <a href='http://xpresspac.com/terms-and-condition' target="_blank">Terms &amp; Conditions</a></span>
          </Grid>
        </Grid>
        <Grid container direction="row" justify="center" alignItems="flex-start" className="margin-top10" spacing={2}>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              disabled={!this.state.tnc}
              onClick={this.handleSubmit}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
        <Backdrop className="loading-indicator" open={this.state.isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    );
  }
}

export default DriverRegistrationComponent;
